// ==========================================
// Core Message Types
// ==========================================
// ==========================================
// Error Types
// ==========================================
export var AppErrorType;
(function (AppErrorType) {
    AppErrorType["CLAUDE_FOLDER_NOT_FOUND"] = "CLAUDE_FOLDER_NOT_FOUND";
    AppErrorType["TAURI_NOT_AVAILABLE"] = "TAURI_NOT_AVAILABLE";
    AppErrorType["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    AppErrorType["INVALID_PATH"] = "INVALID_PATH";
    AppErrorType["API_ERROR"] = "API_ERROR";
    AppErrorType["NETWORK_ERROR"] = "NETWORK_ERROR";
    AppErrorType["UNKNOWN"] = "UNKNOWN";
})(AppErrorType || (AppErrorType = {}));
//# sourceMappingURL=index.js.map